export default {
  title: 'Nueva categoría',
  form: {
    menus: {
      label: 'Menús',
    },
    printer: {
      label: 'Impresora',
    },
    type: {
      label: 'Tipo',
    },
    name: {
      label: 'Nombre',
      placeholder: 'Ingrese el nombre de la categoría',
    },
    description: {
      label: 'Descripción',
      placeholder: 'Ingrese la descripción',
    },
    has_combo_tax: {
      label: 'Tiene impuesto combo',
    },
    modifier_groups: {
      label: 'Grupos de modificadores',
    },
    image: {
      label: 'Imagen',
    },
    identifiers: {
      label: 'Identificadores',
    },
    has_separate_schedule: {
      label: 'Varía del horario del menú',
    },
  },
  buttons: {
    save: 'Guardar',
    close: 'Cerrar',
  },
  feedback: {
    missing_info: 'Información faltante',
  },
  toasts: {
    category_got_created: 'Categoría creada',
    category_got_updated: 'Categoría actualizada',
  },
};
